<template>
  <div>
    <Subheader title="My Assignments" />

    <div class="app-content-column">
      <div class="card">
        <h5>Needs Approval</h5>
        <p>
          Below is a list of projects assigned to you that need your attention and approval. It is
          important to help assigned projects become ready for approval as swiftly as possible.
        </p>
        <p>
          Please review the Project descriptions and ChangeMaker information, and confirm that all
          of the information is accurate. We strongly encourage you to reach out to them directly to
          review and validate all information, and to make any suggestions you have to make their
          project page as effective as possible. Tips to share include:
        </p>

        <ul class="verification-bullets">
          <li>Including photographs</li>
          <li>Creating a compelling story</li>
          <li>
            Being clear about how the needed funding will be used
          </li>
        </ul>
        <h5>Your Assignments</h5>
        <div class="name-list">
          <ul>
            <li v-for="user in usersNeedApproval" :key="user.id" class="bold-name">
              <router-link :to="{ name: 'AssignmentsDetail', params: { userId: user.id } }">
                {{ user.fullName }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="card">
        <h5>All Assignments</h5>
        <form class="form" @submit.stop.prevent="refreshData()">
          <input
            v-model="assignedUsersFilters.search"
            type="text"
            class="input"
            placeholder="Search Assignees"
            @change="refreshData()"
          />
        </form>
        <div class="name-list">
          <ul>
            <li v-for="user in assignedUsers" :key="user.id" class="bold-name">
              <router-link :to="{ name: 'AssignmentsDetail', params: { userId: user.id } }">
                {{ user.fullName }}
              </router-link>
            </li>
          </ul>
          <Pagination
            :pagination-details="assignedUsersPaginationData"
            @update="refreshData($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import Subheader from '@/components/Subheader'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

export default {
  name: 'AssignmentsOverview',
  components: {
    Subheader,
    Pagination,
  },
  data() {
    return {
      usersNeedApprovalFilters: {
        mNeedsApproval: true,
      },
      usersNeedApproval: [],
      usersNeedApprovalPaginationData: {},
      assignedUsersFilters: {
        search: '',
      },
      assignedUsers: [],
      assignedUsersPaginationData: {},
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData(assignedUsersPage = null) {
      // Maybe I could make this one API call instead of two and use a computed property to indicate which ones need approval
      //   // NEED TO EVENTUALLY SUPPORT PAGINATION FOR BOTH PAGES
      // let allUsersFilterWithPageCount = { ...this.usersNeedApprovalFilters }
      // if (allUsersPage) {
      //   allUsersFilterWithPageCount = { ...this.usersNeedApprovalFilters, page: allUsersPage }
      // }
      User.api.listAssignments({ filters: this.usersNeedApprovalFilters }).then(data => {
        this.usersNeedApproval = data.results
        this.usersNeedApprovalPaginationData = getPaginationDataFromResponse(data)
      })
      let assignedUsersFiltersWithPageCount = { ...this.assignedUsersFilters }
      if (assignedUsersPage) {
        assignedUsersFiltersWithPageCount = {
          ...this.assignedUsersFilters,
          page: assignedUsersPage,
        }
      }
      User.api.listAssignments({ filters: assignedUsersFiltersWithPageCount }).then(data => {
        this.assignedUsers = data.results
        this.assignedUsersPaginationData = getPaginationDataFromResponse(data)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/forms';
@import '../styles/layout';

.card {
  @include card-w-borders();
}

.name-list {
  padding-top: 0.5rem;
}

.bold-name {
  font-family: $base-bold-font-family;
  list-style-type: none;
  padding-bottom: 0.5rem;
}

.verification-bullets {
  margin-left: 2rem;
}

li {
  margin-bottom: 1rem;
  line-height: 1.4rem;
  list-style-type: circle;
}
</style>
